import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const CreditImpotJardin = () => {
  // Initialiser Google Ads
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'AW-16912204930');
    }
  }, []);
  const atouts = [
    "Service déclaré et agréé",
    "Jusqu'à 50 % remboursés",
    "Facture claire et justificatif fourni",
    "Aucune démarche compliquée",
    "Tous types de petits travaux éligibles",
    "Intervention à domicile rapide et professionnelle"
  ];

  return (
    <div className="page-container">
      <div className="page-content">
        <div className="section-header">
          <div className="section-badge">Crédit d'impôt jardin</div>
          <h1 className="page-title">Crédit d'impôt jardin</h1>
        </div>

        <div className="modern-section" style={{paddingTop: '2rem'}}>
          <div className="section-container">
            <div className="modern-card" style={{maxWidth: '1000px', margin: '0 auto'}}>
              <h2 style={{
                fontSize: 'clamp(1.5rem, 4vw, 2rem)',
                color: 'var(--color-primary)',
                marginBottom: '1.5rem',
                fontFamily: 'var(--font-heading)'
              }}>
                Crédit d'impôt jardin : comment bénéficier de cet avantage fiscal pour l'entretien de votre jardin ?
              </h2>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                Vous cherchez à réduire vos dépenses d'entretien de jardin tout en embellissant votre extérieur ? Le <strong>crédit d'impôt jardinage</strong> permet de récupérer 50% des sommes engagées, dans la limite de 5 000 € par an et par foyer fiscal. Cet avantage fiscal, accessible aux propriétaires comme aux locataires, s'applique à de nombreuses prestations réalisées par des professionnels agréés, du débroussaillage à la taille des haies.
              </p>
              
              <h3 style={{
                fontSize: 'clamp(1.25rem, 3.5vw, 1.75rem)',
                color: 'var(--color-primary)',
                marginTop: '2.5rem',
                marginBottom: '1rem',
                fontFamily: 'var(--font-heading)'
              }}>
                Le principe du crédit d'impôt pour le jardinage
              </h3>
              
              <h4 style={{
                fontSize: 'clamp(1.1rem, 3vw, 1.5rem)',
                color: 'var(--color-primary)',
                marginTop: '2rem',
                marginBottom: '1rem',
                fontFamily: 'var(--font-heading)'
              }}>
                Définition et fonctionnement de l'avantage fiscal
              </h4>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1rem'}}>
                Le crédit d'impôt pour les travaux de jardinage permet de <strong>récupérer 50% des dépenses engagées</strong>.
              </p>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                Ce dispositif s'inscrit dans le cadre de l'article 199 sexdecies du code général des impôts et concerne les services à la personne. Il représente un véritable coup de pouce financier pour les particuliers souhaitant entretenir leur jardin tout en allégeant leur charge fiscale. La différence principale entre un crédit d'impôt et une réduction d'impôt réside dans le fait que le <strong>premier peut donner lieu à un remboursement</strong> si son montant dépasse celui de l'impôt dû, tandis que la seconde ne peut que diminuer l'impôt à payer.
              </p>
              
              <h4 style={{
                fontSize: 'clamp(1.1rem, 3vw, 1.5rem)',
                color: 'var(--color-primary)',
                marginTop: '2rem',
                marginBottom: '1rem',
                fontFamily: 'var(--font-heading)'
              }}>
                Conditions d'éligibilité au crédit d'impôt
              </h4>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1rem'}}>
                Tous les particuliers domiciliés fiscalement en France <strong>peuvent bénéficier du crédit d'impôt jardinage</strong>.
              </p>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                Les retraités profitent également de cet avantage fiscal depuis janvier 2017, date à laquelle ce dispositif est devenu accessible à tous. Cette mesure a permis de démocratiser l'entretien professionnel des jardins et d'encourager le recours à des jardiniers déclarés. Par ailleurs, les résidences secondaires sont également concernées par <strong>ce crédit d'impôt</strong>, tout comme la résidence principale.
              </p>
              
              <h4 style={{
                fontSize: 'clamp(1.1rem, 3vw, 1.5rem)',
                color: 'var(--color-primary)',
                marginTop: '2rem',
                marginBottom: '1rem',
                fontFamily: 'var(--font-heading)'
              }}>
                Plafonds et limites applicables
              </h4>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1rem'}}>
                Le plafond annuel pour les <strong>travaux de jardinage est fixé</strong> à 5 000 € par foyer fiscal.
              </p>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                Le crédit d'impôt est calculé en appliquant le taux de 50% aux dépenses réellement supportées, après déduction des aides publiques éventuellement perçues. Les propriétaires d'un jardin peuvent donc bénéficier d'un avantage fiscal significatif, dans la limite de 5 000 euros par an et par foyer fiscal, ce qui correspond à un <strong>crédit d'impôt maximal</strong> de 2 500 euros. Si vous dépassez ce plafond, les dépenses excédentaires ne seront malheureusement pas prises en compte dans le calcul du crédit d'impôt.
              </p>
              
              <h3 style={{
                fontSize: 'clamp(1.25rem, 3.5vw, 1.75rem)',
                color: 'var(--color-primary)',
                marginTop: '2.5rem',
                marginBottom: '1rem',
                fontFamily: 'var(--font-heading)'
              }}>
                Les travaux de jardinage éligibles au crédit d'impôt
              </h3>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1rem'}}>
                Les "petits travaux de jardinage" sont définis fiscalement comme des <strong>activités d'entretien courant</strong> de jardins et potagers des particuliers ne nécessitant pas de qualification spécifique.
              </p>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1rem'}}>
                Voici une <strong>liste non exhaustive</strong> des travaux éligibles.
              </p>
              
              <ul style={{
                listStyle: 'none',
                padding: 0,
                marginBottom: '2rem',
                paddingLeft: '1.5rem'
              }}>
                <li style={{marginBottom: '0.75rem', fontSize: 'clamp(0.95rem, 2.5vw, 1.125rem)'}}>
                  <strong>Tonte et débroussaillage</strong> sont éligibles.
                </li>
                <li style={{marginBottom: '0.75rem', fontSize: 'clamp(0.95rem, 2.5vw, 1.125rem)'}}>
                  <strong>L'entretien des massifs</strong> et l'arrosage manuel des végétaux sont inclus.
                </li>
                <li style={{marginBottom: '0.75rem', fontSize: 'clamp(0.95rem, 2.5vw, 1.125rem)'}}>
                  Le <strong>ramassage des feuilles</strong> et la scarification sont pris en compte.
                </li>
                <li style={{marginBottom: '0.75rem', fontSize: 'clamp(0.95rem, 2.5vw, 1.125rem)'}}>
                  L' <strong>application d'engrais et le déneigement</strong> font partie des travaux éligibles.
                </li>
              </ul>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                Ces travaux d'entretien courant permettent de maintenir votre jardin en bon état tout en <strong>bénéficiant d'un avantage fiscal</strong>.
              </p>
              
              <h3 style={{
                fontSize: 'clamp(1.25rem, 3.5vw, 1.75rem)',
                color: 'var(--color-primary)',
                marginTop: '2.5rem',
                marginBottom: '1rem',
                fontFamily: 'var(--font-heading)'
              }}>
                Les démarches pour bénéficier du crédit d'impôt jardinage
              </h3>
              
              <h4 style={{
                fontSize: 'clamp(1.1rem, 3vw, 1.5rem)',
                color: 'var(--color-primary)',
                marginTop: '2rem',
                marginBottom: '1rem',
                fontFamily: 'var(--font-heading)'
              }}>
                Faire appel à des prestataires autorisés
              </h4>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1rem'}}>
                Pour bénéficier du <strong>crédit impôt jardinage</strong>, vous devez faire appel à des entreprises ou des professionnels déclarés auprès des services à la personne.
              </p>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                Le mode prestataire vous permet de confier vos travaux d'entretien de jardin à une entreprise qui s'occupe de tout, depuis le recrutement du jardinier jusqu'à la fourniture du matériel. En emploi direct, vous devenez l'employeur du jardinier et assumez les responsabilités administratives correspondantes. Étant donné cette différence notable, <strong>le mode prestataire offre davantage de simplicité</strong> pour les particuliers souhaitant profiter de l'avantage fiscal sans contraintes administratives supplémentaires.
              </p>
              
              <h4 style={{
                fontSize: 'clamp(1.1rem, 3vw, 1.5rem)',
                color: 'var(--color-primary)',
                marginTop: '2rem',
                marginBottom: '1rem',
                fontFamily: 'var(--font-heading)'
              }}>
                La déclaration fiscale des dépenses
              </h4>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                Les dépenses d'entretien de jardin doivent être indiquées dans la <strong>case 7DB</strong> de votre déclaration de revenus annuels.
              </p>
              
              <h3 style={{
                fontSize: 'clamp(1.25rem, 3.5vw, 1.75rem)',
                color: 'var(--color-primary)',
                marginTop: '2.5rem',
                marginBottom: '1rem',
                fontFamily: 'var(--font-heading)'
              }}>
                L'avance immédiate du crédit d'impôt jardinage
              </h3>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1rem'}}>
                L'avance immédiate du crédit d'impôt est un dispositif permettant de <strong>bénéficier directement d'une réduction de 50%</strong> sur vos factures d'entretien de jardin.
              </p>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                Ce système innovant fonctionne comme un paiement anticipé de votre avantage fiscal. Pour en profiter, votre jardinier ou paysagiste doit proposer ce service via une plateforme mise en place par l'Urssaf. Après validation de votre facture sur le portail en ligne, vous ne payez <strong>que 50% du montant</strong>, tandis que l'Urssaf règle directement la différence au prestataire. Depuis septembre 2023, de nombreux professionnels de l'entretien de jardin proposent ce dispositif qui vous évite d'avancer la totalité des frais pendant plusieurs mois.
              </p>
              
              <h3 style={{
                fontSize: 'clamp(1.25rem, 3.5vw, 1.75rem)',
                color: 'var(--color-primary)',
                marginTop: '2.5rem',
                marginBottom: '1rem',
                fontFamily: 'var(--font-heading)'
              }}>
                Les moyens de paiement autorisés
              </h3>
              
              <h4 style={{
                fontSize: 'clamp(1.1rem, 3vw, 1.5rem)',
                color: 'var(--color-primary)',
                marginTop: '2rem',
                marginBottom: '1rem',
                fontFamily: 'var(--font-heading)'
              }}>
                Les paiements acceptés pour le crédit d'impôt
              </h4>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1rem'}}>
                Pour profiter du crédit d'impôt sur vos travaux de jardinage, vous devez utiliser des moyens de paiement reconnus par l'administration fiscale. Seuls les <strong>paiements acceptés pour l'avantage fiscal</strong>.
              </p>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                Le paiement en espèces n'ouvre pas droit au crédit d'impôt jardin, même si les travaux réalisés sont éligibles. Sachez également que les acomptes versés ne sont pas pris en compte dans le calcul du crédit d'impôt, seul le <strong>règlement intégral et définitif</strong> de la facture est considéré. Par ailleurs, les paiements doivent impérativement être effectués pendant l'année fiscale où vous souhaitez déclarer vos dépenses.
              </p>
              
              <h4 style={{
                fontSize: 'clamp(1.1rem, 3vw, 1.5rem)',
                color: 'var(--color-primary)',
                marginTop: '2rem',
                marginBottom: '1rem',
                fontFamily: 'var(--font-heading)'
              }}>
                Importance d'une facturation conforme
              </h4>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1rem'}}>
                Une facturation conforme constitue un élément important pour bénéficier du crédit d'impôt sur vos travaux de jardinage. L'administration fiscale exige que les factures comportent <strong>plusieurs mentions obligatoires</strong> permettant de justifier la réalité et la nature des prestations réalisées.
              </p>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1rem'}}>
                Voici les <strong>informations essentielles devant figurer</strong> sur une facture.
              </p>
              
              <ul style={{
                listStyle: 'none',
                padding: 0,
                marginBottom: '2rem',
                paddingLeft: '1.5rem'
              }}>
                <li style={{marginBottom: '0.75rem', fontSize: 'clamp(0.95rem, 2.5vw, 1.125rem)'}}>
                  <strong>L'identification complète</strong> de l'émetteur de la facture doit être présente.
                </li>
                <li style={{marginBottom: '0.75rem', fontSize: 'clamp(0.95rem, 2.5vw, 1.125rem)'}}>
                  <strong>L'identification du client</strong>, qu'il soit particulier ou entreprise, est obligatoire.
                </li>
                <li style={{marginBottom: '0.75rem', fontSize: 'clamp(0.95rem, 2.5vw, 1.125rem)'}}>
                  <strong>Le numéro de facture unique</strong> doit être clairement indiqué.
                </li>
                <li style={{marginBottom: '0.75rem', fontSize: 'clamp(0.95rem, 2.5vw, 1.125rem)'}}>
                  Une <strong>description détaillée des prestations</strong> réalisées est indispensable.
                </li>
              </ul>
              
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                Assurez-vous de vérifier systématiquement la conformité de vos factures dès leur réception, sans attendre le moment de votre déclaration fiscale. Une facture incomplète ou mal libellée pourrait entraîner un <strong>rejet de votre crédit d'impôt</strong> en cas de contrôle. Si vous constatez une anomalie, n'hésitez pas à demander immédiatement une correction au professionnel qui a réalisé vos travaux d'entretien de jardin. Conservez ensuite tous vos justificatifs pendant au moins trois ans, durée pendant laquelle l'administration fiscale peut exercer son droit de contrôle sur vos déclarations antérieures.
              </p>
              
              <p className="page-text" style={{fontSize: '1.125rem', marginBottom: '3rem'}}>
                Le crédit d'impôt pour l'entretien de jardin représente une réelle opportunité d'économies fiscales qui mérite attention. En faisant appel à un professionnel déclaré pour vos travaux de jardinage, vous bénéficiez d'une <strong>déduction de 50% des dépenses</strong> engagées, dans la limite de 5 000 € par an. N'oubliez pas de conserver vos justificatifs et de vérifier l'éligibilité de vos prestataires pour profiter pleinement de cet avantage fiscal.
              </p>

              <h3 className="section-title" style={{fontSize: '2rem', marginTop: '3rem', marginBottom: '2rem'}}>
                Nos 6 atouts pour vous faire bénéficier de cet avantage fiscal :
              </h3>

              <ul style={{listStyle: 'none', padding: 0, marginTop: '2rem'}}>
                {atouts.map((atout, index) => (
                  <li key={index} style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '1rem',
                    marginBottom: '1.5rem',
                    padding: '1rem',
                    background: 'var(--color-beige-light)',
                    borderRadius: '12px',
                    transition: 'var(--transition)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'var(--color-accent-light)';
                    e.currentTarget.style.transform = 'translateX(5px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'var(--color-beige-light)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}>
                    <svg width="24" height="24" viewBox="0 0 512 512" fill="currentColor" style={{
                      color: 'var(--color-primary)',
                      flexShrink: 0,
                      marginTop: '2px'
                    }}>
                      <path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"></path>
                    </svg>
                    <span style={{
                      color: 'var(--color-dark)',
                      fontSize: '1.125rem',
                      lineHeight: '1.6',
                      flex: 1
                    }}>{atout}</span>
                  </li>
                ))}
              </ul>

              <div style={{marginTop: '3rem', textAlign: 'center'}}>
                <Link to="/contact" className="modern-button">
                  <span>Demander un devis</span>
                  <svg width="20" height="20" viewBox="0 0 512 512" fill="currentColor">
                    <path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"></path>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditImpotJardin;
